import { ChevronDown } from 'lucide-react';
import * as React from 'react';

import { Button } from '@/components/ui/button';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import { cn } from '@/lib/utils';

const filterPillTriggerClassName = cn(
  'text-xs md:text-sm gap-2 rounded-full',
  'px-1 sm:px-2 md:px-3 md:has-data-[icon=inline-start]:pl-3',
  'max-w-26 sm:max-w-32 md:max-w-40',
  'h-6 sm:h-8 md:h-9',
);

const eventTypeOptionButtonClassName = 'h-9 w-full justify-start font-normal';

export interface FilterButtonProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  label: string;
  onValueChange: (value: boolean | undefined) => void;
  icon?: React.ReactNode;
  popoverContentClassName?: string;
}

export function FilterButton({
  open,
  onOpenChange,
  label,
  onValueChange,
  icon,
  popoverContentClassName,
}: FilterButtonProps) {
  return (
    <Popover open={open} onOpenChange={onOpenChange}>
      <PopoverTrigger
        render={
          <Button type="button" variant="outline" size="sm" className={filterPillTriggerClassName}>
            {icon != null ? (
              <span
                className="shrink-0 text-muted-foreground [&_svg]:size-4"
                data-icon="inline-start"
              >
                {icon}
              </span>
            ) : null}
            <span className="min-w-0 truncate text-foreground">{label}</span>
            <ChevronDown className="size-3 sm:size-4 shrink-0 opacity-50" aria-hidden />
          </Button>
        }
      />
      <PopoverContent align="start" className={cn('w-56 p-1', popoverContentClassName)}>
        <div className="flex flex-col gap-0.5">
          <Button
            variant="ghost"
            size="sm"
            className={eventTypeOptionButtonClassName}
            onClick={() => onValueChange(undefined)}
          >
            Any type
          </Button>
          <Button
            variant="ghost"
            size="sm"
            className={eventTypeOptionButtonClassName}
            onClick={() => onValueChange(true)}
          >
            Online
          </Button>
          <Button
            variant="ghost"
            size="sm"
            className={eventTypeOptionButtonClassName}
            onClick={() => onValueChange(false)}
          >
            In person
          </Button>
        </div>
      </PopoverContent>
    </Popover>
  );
}
